import { useState, useEffect } from 'react';
import API, { SERVER_URL } from '../../api/axios';
import AppLayout from '../../components/layout/AppLayout';
import { S } from '../../components/pageStyles';
import { Loader } from '../../components/ui';
import { LuCamera, LuCircleCheck, LuFileText, LuMinus, LuPackage, LuPencil, LuPlus, LuRuler, LuStore, LuTag, LuTarget, LuTrash2, LuTriangleAlert, LuWallet, LuX } from 'react-icons/lu';

import { fmtF } from '../../theme';
const CONFIGS = {
  boissons: {
    label: 'Boissons',
    categories: ['Vin', 'Bière', 'Liqueur', 'Sucrerie', 'Eaux', 'Jus', 'Cocktail', 'Spiritueux'],
    champsDefaut: [
      { nom: 'Contenant', type: 'select', options: 'Bouteille,Cannette,Fût,Verre,Pression' },
      { nom: 'Volume', type: 'select', options: '25cl,33cl,50cl,65cl,75cl,1L,1.5L' },
      { nom: 'Température', type: 'select', options: 'Fraîche,Ambiante,Chaude' },
    ]
  },
  restaurant: {
    label: 'Restaurant',
    categories: ['Plat principal', 'Entrée', 'Dessert', 'Boisson', 'Menu complet', 'Accompagnement', 'Vin', 'Bière', 'Jus'],
    champsDefaut: [
      { nom: 'Temps de préparation', type: 'text' },
      { nom: 'Ingrédients principaux', type: 'text' },
      { nom: 'Disponibilité', type: 'select', options: 'Midi,Soir,Toute la journée' },
    ]
  },
  vetements: {
    label: 'Vêtements',
    categories: ['Hauts', 'Bas', 'Robes', 'Chaussures', 'Accessoires', 'Sous-vêtements', 'Manteaux', 'Sport'],
    champsDefaut: [
      { nom: 'Taille', type: 'select', options: 'XS,S,M,L,XL,XXL,XXXL,36,37,38,39,40,41,42,43,44,45' },
      { nom: 'Couleur', type: 'text' },
      { nom: 'Matière', type: 'text' },
      { nom: 'Genre', type: 'select', options: 'Homme,Femme,Enfant,Mixte' },
      { nom: 'Marque', type: 'text' },
    ]
  },
  cosmetiques: {
    label: 'Cosmétiques',
    categories: ['Soin visage', 'Soin corps', 'Maquillage', 'Parfum', 'Cheveux', 'Ongles', 'Hygiène', 'Anti-âge'],
    champsDefaut: [
      { nom: 'Marque', type: 'text' },
      { nom: 'Type de peau', type: 'select', options: 'Normale,Sèche,Grasse,Mixte,Sensible,Tous types' },
      { nom: 'Contenance', type: 'text' },
      { nom: 'Genre', type: 'select', options: 'Femme,Homme,Mixte,Enfant' },
    ]
  },
  gaz: {
  label: 'Gaz Butane',
  categories: [
    'B6 (6 kg)',
    'B12 (12kg)', 
    'B15 (15 kg) - réservé aux professionnels',
    'Détendeur',
    'Tuyau flexible',
    'Accessoires'
  ],
  champsDefaut: [
    { nom: 'Poids', type: 'select', options: '6kg,12kg,15kg' },
    { nom: 'Marque', type: 'select', options: 'Pétro Ivoire ,Total ,ORYX ' },
    { nom: 'État', type: 'select', options: 'Pleine,Vide,Consignée' },
    { nom: 'Consigne incluse', type: 'select', options: 'Oui,Non' },
  ]
},
  general: {
    label: 'Général',
    categories: ['Général'],
    champsDefaut: []
  }
};

export default function Produits() {
  const [produits, setProduits] = useState([]);
  const [etablissements, setEtablissements] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [vue, setVue] = useState('liste');
  const [produitSelectionne, setProduitSelectionne] = useState(null);
  const [message, setMessage] = useState('');
  const [recherche, setRecherche] = useState('');
  const [filtreEtab, setFiltreEtab] = useState('tous');
  const [page, setPage] = useState(1);
  const parPage = 10;

  const [etabActuel, setEtabActuel] = useState(null);
  const [secteurStock, setSecteurStock] = useState('general');

  const [form, setForm] = useState({
    nom: '', description: '', code_barre: '',
    prix: '', quantite: '', seuil_alerte: '5',
    unite: 'unite', quantite_par_carton: '1',
    etablissement_id: '', categorie: ''
  });

  const [champsActifs, setChampsActifs] = useState([]);
  const [valeursChamps, setValeursChamps] = useState({});
  const [photoFichier, setPhotoFichier] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [ajoutChamp, setAjoutChamp] = useState(false);
  const [nouveauChamp, setNouveauChamp] = useState({ nom: '', type: 'text', options: '' });

  // Modals appro / perte
  const [modalAppro, setModalAppro] = useState(null);
  const [modalPerte, setModalPerte] = useState(null);
  const [quantiteModal, setQuantiteModal] = useState('');
  const [motifModal, setMotifModal] = useState('');

  useEffect(() => { chargerDonnees(); }, []);

  useEffect(() => {
    if (form.etablissement_id) {
      const etab = etablissements.find(e => e.id === parseInt(form.etablissement_id));
      if (etab) {
        setEtabActuel(etab);
        const secteur = etab.secteur_stock || 'general';
        setSecteurStock(secteur);
        const config = CONFIGS[secteur] || CONFIGS.general;
        setChampsActifs(config.champsDefaut.map((c, i) => ({ ...c, id: 'defaut_' + i })));
        setValeursChamps({});
      }
    }
  }, [form.etablissement_id, etablissements]);

  const chargerDonnees = async () => {
    try {
      const [produitsRes, etabRes] = await Promise.all([
        API.get('/produits'),
        API.get('/etablissements')
      ]);
      setProduits(produitsRes.data.produits || []);
      setEtablissements(etabRes.data.etablissements || []);
    } catch (err) {
      console.error(err);
    } finally {
      setChargement(false);
    }
  };

  const handlePhoto = (e) => {
    const fichier = e.target.files[0];
    if (fichier) {
      setPhotoFichier(fichier);
      setPhotoPreview(URL.createObjectURL(fichier));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      Object.keys(form).forEach(key => {
        if (form[key]) formData.append(key, form[key]);
      });
      if (photoFichier) formData.append('image_principale', photoFichier);

      const champsRemplis = champsActifs
        .filter(c => valeursChamps[c.id])
        .map(c => c.nom + ': ' + valeursChamps[c.id])
        .join(' | ');

      if (champsRemplis) {
        formData.set('description',
          (form.description ? form.description + '\n' : '') + champsRemplis
        );
      }

      if (produitSelectionne) {
          const data = Object.fromEntries(formData);
          data.quantite = form.quantite;
          await API.put('/produits/' + produitSelectionne.id, data);
        setMessage('✅ Produit modifié avec succès !');
      } else {
        await API.post('/produits', formData);
        setMessage('✅ Produit créé avec succès !');
      }

      chargerDonnees();
      setVue('liste');
      setProduitSelectionne(null);
      resetForm();
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
    }
  };

  // Approvisionner
  const handleApprovisionner = (produit) => {
    setModalAppro(produit);
    setQuantiteModal('');
    setMotifModal('');
  };

  const confirmerAppro = async () => {
    if (!quantiteModal || parseInt(quantiteModal) <= 0) {
      setMessage('❌ La quantité doit être supérieure à 0');
      return;
    }
    try {
      await API.post('/produits/' + modalAppro.id + '/approvisionner', {
        quantite: parseInt(quantiteModal),
        motif: motifModal || 'Approvisionnement'
      });
      setMessage('✅ Stock approvisionné de ' + quantiteModal + ' unités !');
      setModalAppro(null);
      chargerDonnees();
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
    }
  };

  // Perte
  const handlePerte = (produit) => {
    setModalPerte(produit);
    setQuantiteModal('');
    setMotifModal('');
  };

  const confirmerPerte = async () => {
    if (!quantiteModal || parseInt(quantiteModal) <= 0) {
      setMessage('❌ La quantité doit être supérieure à 0');
      return;
    }
    if (!motifModal) {
      setMessage('❌ Le motif est obligatoire');
      return;
    }
    try {
      await API.post('/produits/' + modalPerte.id + '/perte', {
        quantite: parseInt(quantiteModal),
        motif: motifModal
      });
      setMessage('✅ Perte de ' + quantiteModal + ' unités enregistrée !');
      setModalPerte(null);
      chargerDonnees();
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
    }
  };

  const handleAjouterChamp = () => {
    if (!nouveauChamp.nom) return;
    const id = 'custom_' + Date.now();
    setChampsActifs([...champsActifs, { ...nouveauChamp, id }]);
    setNouveauChamp({ nom: '', type: 'text', options: '' });
    setAjoutChamp(false);
  };

  const handleSupprimerChamp = (id) => {
    setChampsActifs(champsActifs.filter(c => c.id !== id));
    const newValeurs = { ...valeursChamps };
    delete newValeurs[id];
    setValeursChamps(newValeurs);
  };

  const handleModifier = (produit) => {
    setProduitSelectionne(produit);
    setForm({
      nom: produit.nom || '',
      description: produit.description || '',
      code_barre: produit.code_barre || '',
      prix: produit.prix || '',
      quantite: produit.quantite || '',
      seuil_alerte: produit.seuil_alerte || '5',
      unite: produit.unite || 'unite',
      quantite_par_carton: produit.quantite_par_carton || '1',
      etablissement_id: produit.etablissement_id || '',
      categorie: ''
    });
    if (produit.image_principale) {
      setPhotoPreview(SERVER_URL + '/uploads/produits/' +
        produit.image_principale.replace(/\\/g, '/').split('/').pop());
    }
    setVue('formulaire');
  };

  const handleDesactiver = async (id) => {
    if (!window.confirm('Désactiver ce produit ?')) return;
    try {
      await API.delete('/produits/' + id);
      setMessage('✅ Produit désactivé !');
      chargerDonnees();
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
    }
  };

  const resetForm = () => {
    setForm({
      nom: '', description: '', code_barre: '',
      prix: '', quantite: '', seuil_alerte: '5',
      unite: 'unite', quantite_par_carton: '1',
      etablissement_id: '', categorie: ''
    });
    setChampsActifs([]);
    setValeursChamps({});
    setPhotoFichier(null);
    setPhotoPreview(null);
    setEtabActuel(null);
    setSecteurStock('general');
  };

  const config = CONFIGS[secteurStock] || CONFIGS.general;

  const produitsFiltres = produits.filter(p => {
    const matchRecherche = p.nom.toLowerCase().includes(recherche.toLowerCase()) ||
      (p.code_barre && p.code_barre.includes(recherche));
    const matchEtab = filtreEtab === 'tous' || p.etablissement_id === parseInt(filtreEtab);
    return matchRecherche && matchEtab;
  });

  const totalPages = Math.ceil(produitsFiltres.length / parPage);
  const produitPage = produitsFiltres.slice((page - 1) * parPage, page * parPage);

  if (chargement) return <Loader />;

  return (
    <AppLayout role="admin">

      {/* CONTENU */}
      <div style={styles.contenu}>

        {message && (
          <div role="status" style={{
            ...styles.messageBox,
            background: message.startsWith('✅') ? '#ECFDF5' : '#FEF2F2',
            color: message.startsWith('✅') ? '#047857' : '#B91C1C'
          }}>{message.replace(/^(✅|❌|⚠️)\s*/, '')}</div>
        )}

        {/* MODAL APPROVISIONNEMENT */}
        {modalAppro && (
          <div style={styles.modalOverlay}>
            <div style={styles.modal}>
              <h3 style={{ margin: '0 0 8px', color: '#059669' }}><LuPlus aria-hidden style={{ verticalAlign: '-0.125em' }} /> Approvisionner</h3>
              <p style={{ color: '#475569', fontSize: 13, marginBottom: 16 }}>
                {modalAppro.nom + ' — Stock actuel : ' + modalAppro.quantite + ' ' + modalAppro.unite}
              </p>
              <div style={styles.champGroupe}>
                <label style={styles.label}>Quantité à ajouter *</label>
                <input
                  type="number" min="1"
                  value={quantiteModal}
                  onChange={(e) => setQuantiteModal(e.target.value)}
                  style={styles.input}
                  placeholder="Ex: 50"
                  autoFocus
                />
              </div>
              <div style={{ ...styles.champGroupe, marginTop: 12 }}>
                <label style={styles.label}>Motif</label>
                <input
                  type="text"
                  value={motifModal}
                  onChange={(e) => setMotifModal(e.target.value)}
                  style={styles.input}
                  placeholder="Ex: Livraison fournisseur"
                />
              </div>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
                <button onClick={() => setModalAppro(null)} style={styles.btnAnnuler}>Annuler</button>
                <button onClick={confirmerAppro} style={styles.btnConfirmerAppro}><LuCircleCheck aria-hidden style={{ verticalAlign: '-0.125em' }} /> Confirmer</button>
              </div>
            </div>
          </div>
        )}

        {/* MODAL PERTE */}
        {modalPerte && (
          <div style={styles.modalOverlay}>
            <div style={styles.modal}>
              <h3 style={{ margin: '0 0 8px', color: '#DC2626' }}><LuMinus aria-hidden style={{ verticalAlign: '-0.125em' }} /> Enregistrer une perte</h3>
              <p style={{ color: '#475569', fontSize: 13, marginBottom: 16 }}>
                {modalPerte.nom + ' — Stock actuel : ' + modalPerte.quantite + ' ' + modalPerte.unite}
              </p>
              <div style={styles.champGroupe}>
                <label style={styles.label}>Quantité perdue *</label>
                <input
                  type="number" min="1"
                  value={quantiteModal}
                  onChange={(e) => setQuantiteModal(e.target.value)}
                  style={styles.input}
                  placeholder="Ex: 5"
                  autoFocus
                />
              </div>
              <div style={{ ...styles.champGroupe, marginTop: 12 }}>
                <label style={styles.label}>Motif *</label>
                <input
                  type="text"
                  value={motifModal}
                  onChange={(e) => setMotifModal(e.target.value)}
                  style={styles.input}
                  placeholder="Ex: Produit cassé, périmé..."
                />
              </div>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
                <button onClick={() => setModalPerte(null)} style={styles.btnAnnuler}>Annuler</button>
                <button onClick={confirmerPerte} style={styles.btnConfirmerPerte}><LuCircleCheck aria-hidden style={{ verticalAlign: '-0.125em' }} /> Confirmer</button>
              </div>
            </div>
          </div>
        )}

        {/* HEADER */}
        <div style={styles.header}>
          <div>
            <h1 style={styles.headerTitre}>Produits</h1>
            <p style={styles.headerSousTitre}>
              {produits.length + ' produit(s) • ' +
               produits.filter(p => p.quantite <= p.seuil_alerte).length + ' en alerte'}
            </p>
          </div>
          {vue === 'liste' ? (
            <button
              onClick={() => { resetForm(); setProduitSelectionne(null); setVue('formulaire'); }}
              style={styles.boutonAjouter}>
              + Nouveau Produit
            </button>
          ) : (
            <button onClick={() => setVue('liste')} style={styles.boutonRetour}>
              ← Retour à la liste
            </button>
          )}
        </div>

        {/* ── LISTE ── */}
        {vue === 'liste' && (
          <>
            <div style={styles.filtres}>
              <input
                type="text"
                placeholder="Rechercher par nom ou code-barre..."
                value={recherche}
                onChange={(e) => { setRecherche(e.target.value); setPage(1); }}
                style={styles.rechercheInput}
              />
              <select
                value={filtreEtab}
                onChange={(e) => { setFiltreEtab(e.target.value); setPage(1); }}
                style={styles.filtreSelect}
              >
                <option value="tous">Tous les établissements</option>
                {etablissements.map(e => (
                  <option key={e.id} value={e.id}>{e.nom}</option>
                ))}
              </select>
            </div>

            <div style={styles.section}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHeader}>
                    {['Photo', 'Produit', 'Établissement', 'Prix', 'Stock', 'Statut', 'Actions'].map((h, i) => (
                      <th key={i} style={styles.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {produitPage.map((produit, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? '#F8FAFC' : 'white' }}>
                      <td style={styles.td}>
                        {produit.image_principale ? (
                          <img
                            src={SERVER_URL + '/uploads/produits/' +
                              produit.image_principale.replace(/\\/g, '/').split('/').pop()}
                            alt={produit.nom}
                            style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'cover' }}
                          />
                        ) : (
                          <div style={styles.photoPlaceholder}><LuPackage aria-hidden style={{ verticalAlign: '-0.125em' }} /></div>
                        )}
                      </td>
                      <td style={styles.td}>
                        <div style={{ fontWeight: 700 }}>{produit.nom}</div>
                        {produit.code_barre && (
                          <div style={{ color: '#64748B', fontSize: 11 }}>{' ' + produit.code_barre}</div>
                        )}
                      </td>
                      <td style={styles.td}>{produit.etablissement_nom || 'N/A'}</td>
                      <td style={styles.td}>
                        <span style={{ fontWeight: 700, color: '#2563EB' }}>
                          {fmtF(parseInt(produit.prix))}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <span style={{
                          fontWeight: 700, fontSize: 16,
                          color: produit.quantite === 0 ? '#DC2626'
                            : produit.quantite <= produit.seuil_alerte ? '#EA580C' : '#059669'
                        }}>
                          {produit.quantite}
                        </span>
                        <span style={{ color: '#64748B', fontSize: 11 }}>{' ' + produit.unite}</span>
                      </td>
                      <td style={styles.td}>
                        <span style={{
                          padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 700,
                          background: produit.quantite === 0 ? '#FEF2F2'
                            : produit.quantite <= produit.seuil_alerte ? '#FFF7ED' : '#ECFDF5',
                          color: produit.quantite === 0 ? '#DC2626'
                            : produit.quantite <= produit.seuil_alerte ? '#EA580C' : '#059669'
                        }}>
                          {produit.quantite === 0 ? 'Rupture'
                            : produit.quantite <= produit.seuil_alerte ? 'Alerte' : 'Normal'}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button onClick={() => handleModifier(produit)} style={styles.btnModifier} title="Modifier" aria-label="Modifier"><LuPencil aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                          <button onClick={() => handleApprovisionner(produit)} style={styles.btnAppro} title="Approvisionner" aria-label="Approvisionner"><LuPlus aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                          <button onClick={() => handlePerte(produit)} style={styles.btnPerte} title="Perte" aria-label="Perte"><LuMinus aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                          <button onClick={() => handleDesactiver(produit.id)} style={styles.btnDesactiver} title="Désactiver" aria-label="Désactiver"><LuTrash2 aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {produitsFiltres.length === 0 && (
                <div style={styles.vide}>
                  <div style={{ fontSize: 48 }}><LuPackage aria-hidden style={{ verticalAlign: '-0.125em' }} /></div>
                  <p>Aucun produit trouvé</p>
                </div>
              )}

              {totalPages > 1 && (
                <div style={styles.pagination}>
                  <button onClick={() => setPage(p => Math.max(1, p - 1))}
                    disabled={page === 1}
                    style={{ ...styles.pagBtn, opacity: page === 1 ? 0.4 : 1 }}>←</button>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <button key={i} onClick={() => setPage(i + 1)} style={{
                      ...styles.pagNum,
                      background: page === i + 1 ? 'var(--accent)' : 'white',
                      color: page === i + 1 ? 'white' : '#475569'
                    }}>{i + 1}</button>
                  ))}
                  <button onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                    disabled={page === totalPages}
                    style={{ ...styles.pagBtn, opacity: page === totalPages ? 0.4 : 1 }}>→</button>
                </div>
              )}
            </div>
          </>
        )}

        {/* ── FORMULAIRE ── */}
        {vue === 'formulaire' && (
          <div style={styles.formCard}>
            <h2 style={styles.formTitre}>
              {produitSelectionne ? 'Modifier le produit' : 'Nouveau Produit'}
            </h2>

            <form onSubmit={handleSubmit} encType="multipart/form-data">

              {/* SECTION 1 — ÉTABLISSEMENT */}
              <div style={styles.sectionForm}>
                <div style={styles.sectionFormTitre}><LuStore aria-hidden style={{ verticalAlign: '-0.125em' }} /> Établissement</div>
                <select
                  value={form.etablissement_id}
                  onChange={(e) => setForm({ ...form, etablissement_id: e.target.value, categorie: '' })}
                  style={styles.select}
                  required
                >
                  <option value="">Sélectionnez un établissement</option>
                  {etablissements.map(e => (
                    <option key={e.id} value={e.id}>
                      {e.nom + ' — ' + (CONFIGS[e.secteur_stock]?.label || 'Général')}
                    </option>
                  ))}
                </select>
                {etabActuel && (
                  <div style={styles.secteurBadge}>{config.label} — {etabActuel.nom}</div>
                )}
              </div>

              {/* SECTION 2 — PHOTO + INFOS */}
              <div style={styles.sectionForm}>
                <div style={styles.sectionFormTitre}><LuCamera aria-hidden style={{ verticalAlign: '-0.125em' }} /> Photo & Informations</div>
                <div style={styles.photoSection}>
                  <div style={styles.photoBox}>
                    {photoPreview ? (
                      <img src={photoPreview} alt="Aperçu"
                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 12 }} />
                    ) : (
                      <div style={styles.photoPlaceholderGrand}>
                        <span style={{ fontSize: 40 }}><LuCamera aria-hidden style={{ verticalAlign: '-0.125em' }} /></span>
                        <span style={{ fontSize: 12, color: '#64748B', marginTop: 8 }}>Cliquez pour ajouter</span>
                      </div>
                    )}
                    <input type="file" accept="image/*" onChange={handlePhoto} style={styles.photoInput} />
                  </div>

                  <div style={{ flex: 1 }}>
                    <div style={styles.formGrid}>

                      <div style={{ ...styles.champGroupe, gridColumn: '1 / -1' }}>
                        <label style={styles.label}>
                          {secteurStock === 'restaurant' ? 'Nom du menu *' : 'Nom du produit *'}
                        </label>
                        <input
                          type="text"
                          value={form.nom}
                          onChange={(e) => setForm({ ...form, nom: e.target.value })}
                          style={styles.input}
                          placeholder={
                            secteurStock === 'restaurant' ? 'Ex: Demi-poulet braisé'
                            : secteurStock === 'boissons' ? 'Ex: Heineken 65cl'
                            : secteurStock === 'vetements' ? 'Ex: Robe fleurie'
                            : secteurStock === 'cosmetiques' ? 'Ex: Crème hydratante'
                            : 'Nom du produit'
                          }
                          required
                        />
                      </div>

                      {config.categories.length > 0 && (
                        <div style={styles.champGroupe}>
                          <label style={styles.label}><LuTag aria-hidden style={{ verticalAlign: '-0.125em' }} /> Catégorie</label>
                          <select
                            value={form.categorie}
                            onChange={(e) => setForm({ ...form, categorie: e.target.value })}
                            style={styles.select}
                          >
                            <option value="">Sélectionner...</option>
                            {config.categories.map((cat, i) => (
                              <option key={i} value={cat}>{cat}</option>
                            ))}
                          </select>
                        </div>
                      )}

                      <div style={styles.champGroupe}>
                        <label style={styles.label}><LuWallet aria-hidden style={{ verticalAlign: '-0.125em' }} /> Prix (FCFA) *</label>
                        <input
                          type="number" min="0"
                          value={form.prix}
                          onChange={(e) => setForm({ ...form, prix: e.target.value })}
                          style={styles.input}
                          placeholder="Ex: 1500"
                          required
                        />
                      </div>

                      <div style={styles.champGroupe}>
                        <label style={styles.label}><LuPackage aria-hidden style={{ verticalAlign: '-0.125em' }} /> Quantité *</label>
                        <input
                          type="number" min="0"
                          value={form.quantite}
                          onChange={(e) => setForm({ ...form, quantite: e.target.value })}
                          style={styles.input}
                          placeholder="Ex: 100"
                          required
                        />
                        {produitSelectionne && (
                          <div style={{
                            background: '#FFF7ED', color: '#EA580C',
                            padding: '6px 10px', borderRadius: 8, fontSize: 11, marginTop: 4
                          }}>
                            <LuTriangleAlert aria-hidden style={{ verticalAlign: '-0.125em' }} /> Modifier la quantité ici remplace le stock actuel. Pour un ajout ou une perte utilisez <LuPlus aria-hidden style={{ verticalAlign: '-0.125em' }} /> <LuMinus aria-hidden style={{ verticalAlign: '-0.125em' }} /> depuis la liste.
                          </div>
                        )}
                      </div>

                      <div style={styles.champGroupe}>
                        <label style={styles.label}><LuTriangleAlert aria-hidden style={{ verticalAlign: '-0.125em' }} /> Seuil d'alerte</label>
                        <input
                          type="number" min="0"
                          value={form.seuil_alerte}
                          onChange={(e) => setForm({ ...form, seuil_alerte: e.target.value })}
                          style={styles.input}
                          placeholder="Ex: 5"
                        />
                      </div>

                      {secteurStock !== 'restaurant' && (
                        <>
                          <div style={styles.champGroupe}>
                            <label style={styles.label}><LuRuler aria-hidden style={{ verticalAlign: '-0.125em' }} /> Unité</label>
                            <select
                              value={form.unite}
                              onChange={(e) => setForm({ ...form, unite: e.target.value })}
                              style={styles.select}
                            >
                              <option value="unite">Unité</option>
                              <option value="bouteille">Bouteille</option>
                              <option value="carton">Carton</option>
                              <option value="litre">Cannette</option>
                              <option value="piece">Packs</option>
                              <option value="bouteille_gaz">Bouteille Gaz</option>
                            </select>
                          </div>
                          <div style={styles.champGroupe}>
                            <label style={styles.label}><LuPackage aria-hidden style={{ verticalAlign: '-0.125em' }} /> Qté par Casier ou carton</label>
                            <input
                              type="number" min="1"
                              value={form.quantite_par_carton}
                              onChange={(e) => setForm({ ...form, quantite_par_carton: e.target.value })}
                              style={styles.input}
                              placeholder="Ex: 24"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* SECTION 3 — CHAMPS SPÉCIFIQUES */}
              {form.etablissement_id && (
                <div style={styles.sectionForm}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <div style={styles.sectionFormTitre}><LuTarget aria-hidden style={{ verticalAlign: '-0.125em' }} /> Champs Spécifiques {config.label}</div>
                    <button type="button" onClick={() => setAjoutChamp(!ajoutChamp)} style={styles.btnAjouterChampBtn}>
                      {ajoutChamp ? 'Annuler' : 'Ajouter un champ'}
                    </button>
                  </div>

                  {ajoutChamp && (
                    <div style={styles.ajoutChampBox}>
                      <div style={styles.formGrid}>
                        <div style={styles.champGroupe}>
                          <label style={styles.label}>Nom du champ</label>
                          <input
                            type="text"
                            value={nouveauChamp.nom}
                            onChange={(e) => setNouveauChamp({ ...nouveauChamp, nom: e.target.value })}
                            style={styles.input}
                            placeholder="Ex: Millésime"
                          />
                        </div>
                        <div style={styles.champGroupe}>
                          <label style={styles.label}>Type</label>
                          <select
                            value={nouveauChamp.type}
                            onChange={(e) => setNouveauChamp({ ...nouveauChamp, type: e.target.value })}
                            style={styles.select}
                          >
                            <option value="text">Texte libre</option>
                            <option value="number">Nombre</option>
                            <option value="select">Liste déroulante</option>
                          </select>
                        </div>
                        {nouveauChamp.type === 'select' && (
                          <div style={{ ...styles.champGroupe, gridColumn: '1 / -1' }}>
                            <label style={styles.label}>Options (séparées par virgules)</label>
                            <input
                              type="text"
                              value={nouveauChamp.options}
                              onChange={(e) => setNouveauChamp({ ...nouveauChamp, options: e.target.value })}
                              style={styles.input}
                              placeholder="Ex: Rouge,Blanc,Rosé"
                            />
                          </div>
                        )}
                      </div>
                      <button type="button" onClick={handleAjouterChamp} style={styles.btnConfirmerChamp}>
                        <LuCircleCheck aria-hidden style={{ verticalAlign: '-0.125em' }} /> Confirmer l'ajout
                      </button>
                    </div>
                  )}

                  <div style={styles.formGrid}>
                    {champsActifs.map((champ) => (
                      <div key={champ.id} style={styles.champDynamique}>
                        <div style={styles.champGroupe}>
                          <label style={styles.label}>
                            {champ.nom}
                            <button type="button" onClick={() => handleSupprimerChamp(champ.id)}
                              style={styles.btnSupprimerInline} aria-label="Supprimer" title="Supprimer"><LuX aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                          </label>
                          {champ.type === 'select' ? (
                            <select
                              value={valeursChamps[champ.id] || ''}
                              onChange={(e) => setValeursChamps({ ...valeursChamps, [champ.id]: e.target.value })}
                              style={styles.select}
                            >
                              <option value="">Sélectionner...</option>
                              {(champ.options || '').split(',').map((opt, j) => (
                                <option key={j} value={opt.trim()}>{opt.trim()}</option>
                              ))}
                            </select>
                          ) : (
                            <input
                              type={champ.type === 'number' ? 'number' : 'text'}
                              value={valeursChamps[champ.id] || ''}
                              onChange={(e) => setValeursChamps({ ...valeursChamps, [champ.id]: e.target.value })}
                              style={styles.input}
                              placeholder={'Entrez ' + champ.nom.toLowerCase()}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  {champsActifs.length === 0 && !ajoutChamp && (
                    <p style={{ color: '#64748B', fontSize: 13 }}>
                      Cliquez sur "<LuPlus aria-hidden style={{ verticalAlign: '-0.125em' }} /> Ajouter un champ" pour personnaliser ce formulaire.
                    </p>
                  )}
                </div>
              )}

              {/* SECTION 4 — DESCRIPTION */}
              <div style={styles.sectionForm}>
                <div style={styles.sectionFormTitre}><LuFileText aria-hidden style={{ verticalAlign: '-0.125em' }} /> Description / Notes</div>
                <textarea
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                  style={{ ...styles.input, height: 80, resize: 'vertical' }}
                  placeholder={secteurStock === 'restaurant' ? 'Ingrédients, allergènes, notes...' : 'Description du produit...'}
                />
              </div>

              {/* ACTIONS */}
              <div style={styles.formActions}>
                <button type="button" onClick={() => setVue('liste')} style={styles.btnAnnuler}>
                  Annuler
                </button>
                <button type="submit" style={styles.btnSauvegarder}>
                  {produitSelectionne ? 'Sauvegarder' : 'Créer le produit'}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </AppLayout>
  );
}

const styles = {
  chargement: {
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', height: '100vh', fontSize: 24, color: '#475569'
  },
  contenu: { ...S.contenu, flex: 1 },
  messageBox: { ...S.messageBox, marginBottom: 16 },
  modalOverlay: S.modalOverlay,
  modal: { ...S.modal, width: 'min(420px, 100%)' },
  header: S.header,
  headerTitre: S.headerTitre,
  headerSousTitre: S.headerSousTitre,
  boutonAjouter: S.boutonAjouter,
  boutonRetour: S.boutonRetour,
  filtres: { ...S.filtres, marginBottom: 16 },
  rechercheInput: { ...S.rechercheInput },
  filtreSelect: { ...S.filtreSelect, minWidth: 200 },
  section: S.section,
  table: { ...S.table, width: '100%' },
  tableHeader: S.tableHeader,
  th: S.th,
  td: S.td,
  photoPlaceholder: {
    width: 40, height: 40, borderRadius: 8, background: '#F8FAFC',
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20
  },
  btnModifier: S.btnModifier,
  btnAppro: S.btnAppro,
  btnPerte: S.btnPerte,
  btnDesactiver: S.btnDesactiver,
  btnConfirmerAppro: {
    padding: '10px 20px', background: '#059669',
    color: 'white', border: 'none', borderRadius: 10,
    cursor: 'pointer', fontWeight: 700, fontSize: 14
  },
  btnConfirmerPerte: {
    padding: '10px 20px', background: '#DC2626',
    color: 'white', border: 'none', borderRadius: 10,
    cursor: 'pointer', fontWeight: 700, fontSize: 14
  },
  vide: S.vide,
  pagination: { ...S.pagination, marginTop: 16 },
  pagBtn: S.pagBtn,
  pagNum: { ...S.pagNum, width: 30 },
  formCard: S.formCard,
  formTitre: { ...S.formTitre, marginBottom: 24 },
  sectionForm: { ...S.sectionForm, marginBottom: 24 },
  sectionFormTitre: { ...S.sectionFormTitre, marginBottom: 16 },
  secteurBadge: {
    marginTop: 10, padding: '6px 14px', background: '#EFF6FF', color: '#2563EB',
    borderRadius: 20, fontSize: 13, fontWeight: 700, display: 'inline-block'
  },
  photoSection: { display: 'flex', gap: 20, alignItems: 'flex-start' },
  photoBox: {
    width: 140, height: 140, borderRadius: 12, border: '2px dashed #E2E8F0',
    overflow: 'hidden', cursor: 'pointer', position: 'relative', flexShrink: 0, background: '#F8FAFC'
  },
  photoPlaceholderGrand: {
    width: '100%', height: '100%',
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
  },
  photoInput: { position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer', width: '100%', height: '100%' },
  formGrid: S.formGrid,
  champGroupe: S.champGroupe,
  label: { ...S.label, display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  input: { ...S.input, width: '100%' },
  select: { ...S.select, width: '100%' },
  btnAjouterChampBtn: {
    padding: '6px 14px', background: '#ECFDF5', color: '#059669',
    border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 13
  },
  ajoutChampBox: {
    background: 'white', borderRadius: 10, padding: 16,
    marginBottom: 16, border: '2px dashed #059669'
  },
  btnConfirmerChamp: {
    marginTop: 12, padding: '8px 16px', background: '#059669',
    color: 'white', border: 'none', borderRadius: 8,
    cursor: 'pointer', fontWeight: 700, fontSize: 13
  },
  champDynamique: { position: 'relative' },
  btnSupprimerInline: {
    background: 'none', border: 'none', cursor: 'pointer', fontSize: 11, color: '#DC2626', padding: '0 4px'
  },
  formActions: { ...S.formActions, marginTop: 16 },
  btnAnnuler: S.btnAnnuler,
  btnSauvegarder: S.btnSauvegarder
};